import {useEffect} from 'react';
import {MODULE_LIST, MODULE_MICROSOFT_GRAPH_URL} from "v4/data/apiRoutes";
import useFetch from "v4/hooks/useFetch";
import {generateUrl} from "v4/services/api.service";

const MODULE_MICROSOFT_GRAPH_ID = 'module_microsoft_graph';

/**
 * Lien de consentement de l'ancien module Microsoft Graph (legacy), récupéré seulement si le module est actif.
 */
export default function useMicrosoftGraphConnection(customerId) {
    const [{data: modules}, fetchModules] = useFetch();
    const [{data: connection, isError, isFinished}, fetchConnection] = useFetch();

    useEffect(() => {
        fetchModules({
            url: generateUrl(MODULE_LIST, {customerId}),
            config: {method: 'GET'},
        });
    }, [fetchModules, customerId]);

    const isMicrosoftGraphEnabled = !!modules?.['hydra:member']?.some(module => module.id === MODULE_MICROSOFT_GRAPH_ID && true === module.isEnabled);

    useEffect(() => {
        if (isMicrosoftGraphEnabled) {
            fetchConnection({
                url: generateUrl(MODULE_MICROSOFT_GRAPH_URL, {id: MODULE_MICROSOFT_GRAPH_ID, customerId}),
                config: {method: 'GET'},
            });
        }
    }, [isMicrosoftGraphEnabled, fetchConnection, customerId]);

    return isFinished && !isError ? connection : null;
}
